module.exports = __webpack_public_path__ + "img/adhka-yx1zn.008.90d23d17.jpeg";